export default __webpack_public_path__ + "static/media/SchoolProject2.1ef2012b.jpeg";